import React, { useState } from 'react';
import { Box, Divider, Typography } from "@mui/material";
import { SubmitButton } from "src/components/Button/SubmitButton";
import { AssignModal } from "src/components/Modal/AssignModal";
import { StudioCategoriesTable } from 'src/components/StudioCategoriesTable';
import { PlusIcon } from "src/Icons";

import { EmptyState } from "./EmptyState";
import { SimpleCategoryCard } from "./SimplifiedCategoryCard";

interface ServiceCategoryStepProps {
  categories: Array<any>;
  preSelectedCats: Array<any>;
  preAssignedCats: Array<any>;
  onCardClick: (value: any) => void;
  onPopupCardClick: (value: any) => void;
  checkedArray?: any;
  onCategoryCheckChange: (category: any) => void;
  onServiceCheckChange: (service: any) => void;
}

const ServiceCategoryStep = ({
  categories,
  preSelectedCats,
  preAssignedCats,
  onCardClick,
  onPopupCardClick,
  checkedArray,
  onCategoryCheckChange,
  onServiceCheckChange,
}: ServiceCategoryStepProps) => {

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const checkSelection = (id: number) => {
    return preSelectedCats.map(cat => +cat.id).includes(id)
  }

  const addCategoryClick = () => {
    setIsModalOpen(true);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
      }}
    >
      <AssignModal
        openedFrom="sidebar"
        isOpen={isModalOpen}
        categories={categories}
        assignedCategories={preAssignedCats}
        onClose={() => setIsModalOpen(false)}
        onSubmit={() => setIsModalOpen(false)}
        onSelect={onPopupCardClick}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          maxWidth: '270px',
          minWidth: '270px',
          padding: '20px 24px 0px',
          backgroundColor: "#FAFAFA",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: '600',
            }}
          >
                Choose category
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: '400',
              marginTop: '4px',
              marginBottom: '18px',
            }}
          >
                Choose template categories to select  services you want to attach to the studio
          </Typography>
        </Box>

        <SubmitButton
          sx={{
            width: '100%',
            minHeight: '48px',
            fontSize: '16px',
            fontWeight: '400',
          }}
          title="Choose categories"
          endIcon={<PlusIcon sx={{height: '24px', width: '24px', margin: '8px',}}/>}
          onClick={addCategoryClick}
        />

        <Divider
          component="div"
          sx={{
            marginTop: '24px',
            marginBottom: '10px',
            color: '#B9B9B9',
          }}
        />

        <Box>
          {preAssignedCats.map((category: any) => (
            <SimpleCategoryCard
              key={category.id}
              isSelected={checkSelection(+category.id)}
              category={category}
              onClick={onCardClick}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          padding: '25px 25px 76px 30px',
          width: "100%",
          overflowX: 'auto',
        }}
      >
        {preAssignedCats.length < 1 ?
          <EmptyState
            sx={{paddingTop: '184px'}}
            img="/images/empty-page-states/services.png"
            header="Choose category first to create service list"
            text="Choose categories from templates to select services you want to attach to particular studio."
          />
          :
          //add paddingBottom to prevent overlap with bottom bar
          <Box >
            <Typography sx={{
              color: '#080808',
              fontWeight: '600',
              fontSize: '18px',
              marginBottom: '30px',
            }}>
              {'Choose services you want to link to the studio'}
            </Typography>

            <StudioCategoriesTable
              withoutFilterSection
              withoutEditing
              withSelection
              checkedArray={checkedArray}
              onServiceCheckChange={onServiceCheckChange}
              onCategoryCheckChange={onCategoryCheckChange}
              studioCategories = {preSelectedCats?.length > 0 ? preSelectedCats : preAssignedCats}
            />
          </Box>
        }
      </Box>
    </Box>
  );
};

export {ServiceCategoryStep}
